import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import authReducer from './auth';
import userReducer from './user';
import carInsuranceReducer from './carInsurance';
import insuranceTypesReducer from './InsuranceTypes';
import insurancePoliciesReducer from './insurancePolicies';
import insurancePlansReducer from './InsurancePlans';
import paymentsReducer from './payments';
import errorsReducer from './errors';
import techModelReducer from './techModel';
import hogarModelReducer from './hogarModel';
import insuranceToDisableReducer from './insuranceToDisable';
import lifeExtraDataReducer from './lifeExtraData';
import dismiss from './dismiss';
import petReducer from './petData';
import activityReducer from './activityData';
import activityNameReducer from './activityNameData';
import taxesDataReducer from './taxesData';

export default function createRootReducer(history) {
  return combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    user: userReducer,
    carInsurance: carInsuranceReducer,
    insurances: insuranceTypesReducer,
    insurancePolicies: insurancePoliciesReducer,
    insurancePlans: insurancePlansReducer,
    payments: paymentsReducer,
    error: errorsReducer,
    techModel: techModelReducer,
    hogarModel: hogarModelReducer,
    insuranceToDisable: insuranceToDisableReducer,
    dismiss: dismiss,
    lifeExtraData: lifeExtraDataReducer,
    pet: petReducer,
    activity: activityReducer,
    activityName: activityNameReducer,
    taxes: taxesDataReducer,
  });
}
